/** @jsx jsx */
import { jsx, Image, SxProps } from '@themed';

interface PacmanLoaderProps extends SxProps {
  id?: string;
}
export const PacmanLoader = (props: PacmanLoaderProps) => <Image src='/images/pacman-transparent.gif' alt='loading...' {...props} />;
